<template>
  <v-container fluid class="theme-color" style="height: 100%; overflow-x:scroll;">
    <AirReport />
  </v-container>
</template>

<script>
import AirReport from '../components/air-executive/AirReport.vue';

export default {
  name: 'AirExecutive',
  components: {
    AirReport
  },
  data: () => ({}),
  mounted() {
    this.$emit('gobacktolink', 'report-executive');
  },
  methods: {}
};
</script>
